import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { shallowRef, onBeforeMount, nextTick } from 'vue';
import PopoverService from '@/services/popover';
import BaseModal from '@/components/modals/BaseModal.vue';
import { useEmbeddedModalPosition } from '@/composables/useEmbeddedModalPosition';

interface IModal {
  component: typeof BaseModal;
  dismiss: () => void;
  approve: (value?: unknown) => void;
  props: object;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopoverRoot',
  setup(__props) {

const { containerClasses, containerStyle } = useEmbeddedModalPosition();
const modal = shallowRef(null as IModal | null);

const open = function (
  component: typeof BaseModal,
  props: object,
  resolve: (value: unknown) => void
) {
  modal.value?.dismiss();

  // Wait before the previous modal is properly dismissed.
  nextTick(() => {
    modal.value = {
      component,
      props,
      dismiss: () => {
        close();
        resolve('modal-dismissed');
      },
      approve: (value?: unknown) => {
        close();
        resolve({ status: 'modal-approved', value });
      }
    };
  });
};

const close = function () {
  modal.value = null;
};

onBeforeMount(() => {
  PopoverService.eventBus.on(
    'open',
    (
      component: typeof BaseModal,
      props: object,
      resolve: (value: unknown) => void
    ) => open(component, props, resolve)
  );
});

return (_ctx: any,_cache: any) => {
  return (modal.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['popover-container', ..._unref(containerClasses)]),
        style: _normalizeStyle(_unref(containerStyle))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(modal.value.component), _normalizeProps(_guardReactiveProps({
        ...modal.value.props,
        approve: modal.value.approve,
        dismiss: modal.value.dismiss
      })), null, 16))
      ], 6))
    : _createCommentVNode("", true)
}
}

})